<template>
  <div>
    <b-form class="needs-validation">

      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Subscriber Macaddress</span>
          </p>
        </b-col>
        <b-col xl="7" lg="7" sm="7">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="addressStatus"
              v-model="topOffPlansForm.address"
            ></b-form-input>
            <b-form-invalid-feedback :state="addressStatus">
              Please enter a valid subscriber mac address.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Data Plan (TopOff)</span>
          </p>
        </b-col>
        <b-col xl="7" lg="7" sm="7">
          <b-form-group label-for="input-1">
            <b-form-select
              id="period"
              v-model="topOffPlansForm.dataPlan"
              :options="dataPlanOption"
              :state="dataPlanStatus"
              value-field="key"
              class="mt-2"
              text-field="label"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
            Close
        </base-button>
        <base-button type="primary" title="Submit" v-on:click="topOffPlansSubmit()" :loading="submitLoading">
            Submit
        </base-button>
      </div>
    </b-form>

  </div>
</template>

<script>
  import administratorService from "../../common/api-services/administrator-service";
  import handleResponse from "../../common/directive/handlResponse";

  export default {
    name: "Top-Off-Plans-Subscriber",
    computed: {
      addressStatus() {
        return this.topOffPlansForm.address.length > 0
      },
      dataPlanStatus() {
        return this.topOffPlansForm.dataPlan.length > 0
      }
    },
    data() {
      return {
        topOffPlansForm: {
          address: '',
          dataPlan: '10'
        },
        dataPlanOption: [],
        editStatus: false,
        submitLoading: false
      }
    },
    mounted() {
      this.$root.$on('editTopOffPlansSub', (res => {
        this.topOffPlansForm.address = res
      }))
      this.getDataPlanFunc()
    },
    methods: {
      getDataPlanFunc() {
        this.dataPlanOption = []
        administratorService.getDslTopOffPlans().then(res => {
          res.map(item => {
            let items = {key: item.amount, label: item.description};
            this.dataPlanOption.push(items)
          })
        })
      },

      modalClose() {
        this.$bvModal.hide('top-off-plans-subscriber');
      },

      topOffPlansSubmit() {
        if (this.addressStatus && this.dataPlanStatus) {
          this.submitLoading = true;
          this.addTopOffPlans()
        }
      },

      addTopOffPlans(method) {
        administratorService.setDslTopOff( this.topOffPlansForm).then(res => {
          this.submitLoading = false;
          if (res && res.response) {
            let {type, msg} = handleResponse.apiResponse(res.response);
            this.$toast(msg, {type: type})
          } else {
            let {type, msg} = handleResponse.apiResponse(res.response_msg);
            this.$toast(msg, {type: type})
          }
          this.modalClose();
          this.$root.$emit('newBrandSubscriberAdded', true)
        })
      }
    }
  }
</script>

<style scoped>

</style>
